import {parseInt} from "lodash/string";
import {
    dataLayerAddItem, 
    dataLayerButtonsInit, 
    dataLayerSavingsCalculator, 
    stepDataLayer
} from "./saving-calculator-ga4";

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('.item-input');
        this.changeEvent = new Event('change', { bubbles: true })

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        if (event.target.name === 'plus') {
            this.input.stepUp();
            const itemTitle = this.input.getAttribute('data-item-title')
            dataLayerAddItem(itemTitle)
        } else {
            this.input.stepDown();
        }
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

class SavingItem extends HTMLElement {
    constructor() {
        super();
        this.QuantityInput = this.querySelector('quantity-input');
        this.QuantityInput.input.addEventListener('change', (e) => {
            this.quantityUpdate(e.target.value)
        })
        this.addingBtn = this.querySelector('.list-item__adding')
        this.addingBtn.addEventListener('click', () => {
            const itemTitle = this.QuantityInput.input.getAttribute('data-item-title')
            this.QuantityInput.input.stepUp()
            this.quantityUpdate(this.QuantityInput.input.value)
            dataLayerAddItem(itemTitle)
        })
        this.selectedList = []
    }

    quantityUpdate(qty) {
        const currentQty = parseInt(qty)
        this.setAttribute('data-qty',qty)
        currentQty > 0 ? this.classList.add('added') : this.classList.remove('added')
    }
}

class SavingPopup extends HTMLElement {
    constructor() {
        super();
        this.dataItems = this.getDataItems()
        this.currentStep = 1
        stepDataLayer(this.currentStep)
        this.querySelectorAll('.step-button').forEach((el) => {
            el.addEventListener('click', (e) => {
                e.target.name === 'plus' ? this.currentStep = this.currentStep + 1 : this.currentStep = this.currentStep - 1
                this.changeStep()
                stepDataLayer(this.currentStep)
            })
        })

        dataLayerButtonsInit(this)
    }

    getDataItems () {
        this.dataItems = this.dataItems || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.dataItems
    }

    changeStep() {
        const stepEls = document.querySelectorAll('.saving-step')
        stepEls.forEach((el) => {
            el.classList.remove('active')
        })
        const activeStep = document.querySelector(`.saving-step[data-step="${this.currentStep}"]`)
        const topScroll = this.offsetTop - 65

        if(activeStep) activeStep.classList.add('active')
        window.scrollTo(0,topScroll)

        if (this.currentStep === 3) this.buildSavingTable()
    }

    buildSavingTable () {
        this.selectedList = []
        const selectedLists = document.querySelectorAll('.list-item.added')
        const table = this.querySelector('#table')
        const savedEl  = this.querySelector('#saved-price')
        const zipEl = this.querySelector('.zip-payment')
        const zipThreshold = parseInt(zipEl.getAttribute('data-threshold'))


        selectedLists.forEach((el) => {
            const index = el.getAttribute('data-index')
            const qty = el.getAttribute('data-qty')
            const title = el.getAttribute('data-title')
            let dataItem = this.dataItems[index]
            dataItem['qty'] = parseInt(qty)
            dataItem['title'] = title
            this.selectedList.push(dataItem)
        })
        const savedPrice = this.savedCalculator(this.selectedList)
        const totalUniqueItemCount = this.totalUniqueItemCount(this.selectedList)

        dataLayerSavingsCalculator(savedPrice, totalUniqueItemCount)

        zipThreshold >= savedPrice ? zipEl.style.display = 'none' : zipEl.style.display = 'block'

        savedEl.innerHTML = `$${savedPrice}`
        table.innerHTML = this.htmlTableBuild(this.selectedList)

    }
    savedCalculator (data) {
        let totalSaved = 0
        data.forEach((item) => {
            totalSaved = totalSaved + (item.price_store - item.price_thermomix) * item.qty
        })
        return totalSaved.toFixed(2)
    }

    totalUniqueItemCount (data) {
        let total = data.length
        return total
    }

    htmlTableBuild (data) {
        let html = ''
        data.forEach((item) => {
            let image = ''
            if (item.svg) {
                image = item.svg
            } else {
                image = `<img src="${item.icon}" />`
            }
            html += `<div class="saving-item">
                            <div class="saving-left">
                                <div class="item-info">
                                    <div class="item-info-image">
                                        ${image}
                                    </div>
                                    <div class="item-info-details">
                                        <h5>${item.title}</h5>
                                        <div>${item.number_unit} ${item.unit}</div>
                                        <span class="item-info-qty">${item.qty}</span>
                                    </div>
                                </div>
                                <div class="item-info-name">
                                    <div>Store Bought</div>
                                    <div class="color-green">Thermomix</div>
                                </div>
                            </div>
                            <div class="saving-right">
                                <div class="saving-price">
                                    <span>$${(item.price_store).toFixed(2)}</span>
                                    <span class="color-green">$${(item.price_thermomix).toFixed(2)}</span>
                                </div>
                                <div class="saving-price">
                                    <span>$${(item.price_store * item.qty).toFixed(2)}</span>
                                    <span class="color-green">$${(item.price_thermomix * item.qty).toFixed(2)}</span>
                                </div>
                            </div>
                        </div>`
        })
        return html
    }
}

const initSavingCalculator = () => {
    customElements.define('quantity-input', QuantityInput);
    customElements.define('saving-item', SavingItem);
    customElements.define('saving-popup', SavingPopup);
}
export default initSavingCalculator;